import React from 'react'
import { Box } from 'theme-ui'
import PoweredByGatsby from '@components/PoweredByGatsby'
import { HeaderLogo } from '../Header/Header.Logo'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'
import { Card, Text, IconButton } from 'theme-ui'
import { FaPhone, FaEnvelope, FaLocationArrow } from 'react-icons/fa'
import Section from '@components/Section'
const styles = {
  logo: {
    pb: 1,
    mb: 2,
    mt: [4, 0]
  },
  copyright: {
    pt: 2,
  }
}

export const FooterLogo = () =>{
  const { phone, address, email } = useSiteMetadata()

  return  (
    <>
      <Box sx={styles.logo}>
        <HeaderLogo  />
      </Box>
      <Box sx={styles.copyright}>
        © {new Date().getFullYear()}, All Rights Reserved.
      </Box>
      <Box>
      {phone && (
          <Text>
            <IconButton variant='simple' role='presentation'>
              <FaPhone />
            </IconButton>
            {phone}
          </Text>
        )}
        {email && (
          <Text>
            <IconButton variant='simple' role='presentation'>
              <FaEnvelope />
            </IconButton>
            {email}
          </Text>
        )}
        {address && (
          <Text>
            <IconButton variant='simple' role='presentation'>
              <FaLocationArrow />
            </IconButton>
            {address}
          </Text>
        )}
      </Box>
      <Box>
        <PoweredByGatsby />
      </Box>
    </>
  )
}
